import { axios } from '@/utils/request'

export function dropProjectList () {
  return axios({
    url: `/projectInfo/dropDown`,
    method: 'Get'
  })
}

export function dropProjectByType (type) {
  return axios({
    url: `/projectInfo/dropDownByType/${type}`,
    method: 'Get'
  })
}